import React, { useContext } from "react";
import CurrentUserContext from "../../../../contexts/CurrentUserContext";
import { ListEmpty } from "./ListEmpty";
import { Skeleton } from "@mui/material";
import { usePetsByEmail } from "../../../../hooks/Pets/usePetsByEmail";
import { ListPets } from "./ListPets";
import { usePersonByEmail } from "../../../../hooks/Person/usePersonByEmail";
import { ListPersons } from "./ListPersons";

export const ListQrs = () => {
  const { isLoadingUser } = useContext(CurrentUserContext);
  const { data: listPets, isLoading: isLoadingPets } = usePetsByEmail();
  const { data: listPersons, isLoading: isLoadingPersonas } =
    usePersonByEmail();

  const hasPersons = listPersons?.length > 0;
  const hasPets = listPets?.length > 0;

  if (isLoadingPets || isLoadingPersonas || isLoadingUser)
    return (
      <>
        <Skeleton height={50} />
        <Skeleton height={50} />
      </>
    );

  if (hasPersons || hasPets)
    return (
      <>
        {hasPersons && <ListPersons list={listPersons} />}
        {hasPets && <ListPets list={listPets} />}
      </>
    );

  return <ListEmpty />;
};
